import(/* webpackMode: "eager" */ "D:\\CL_Educate_apps\\cl-verse\\node_modules\\next\\dist\\client\\link.js");
